<div class="view-wrapper">
    <dx-load-panel container=".view-wrapper-scroll" [visible]="isLoading" [showPane]="false"
        [position]="{ of: 'user-profile' }">
    </dx-load-panel>
    <dx-scroll-view class="view-wrapper-scroll" (onScroll)="scroll($event)">
        <div *ngIf="!isLoading" class="cards-container">
            <div class="panel">
                <div class="title-text panel-header">
                    Complience Dashboard
                </div>

                <app-merchant-compliance></app-merchant-compliance>
            </div>
        </div>
    </dx-scroll-view>
</div>